(() => {
  const SERVICE_SELECTOR = '[data-service-key="moving-organization"]';
  const CONFIG_SELECTOR = '[data-bcu-moving-date-config]';

  if (window.__bcuMovingOrganizationEnhancementsBooted) return;
  window.__bcuMovingOrganizationEnhancementsBooted = true;

  const parseConfig = () => {
    const source = document.querySelector(CONFIG_SELECTOR);
    if (!source) return {};
    try {
      return JSON.parse(source.textContent || '{}');
    } catch (_error) {
      return {};
    }
  };

  const config = parseConfig();
  const blockedDates = new Set(
    String(config.blockedDates || '')
      .split(/[\s,;]+/)
      .map((value) => value.trim())
      .filter((value) => /^\d{4}-\d{2}-\d{2}$/.test(value)),
  );

  const dateValue = (date) => [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');

  const dateFromValue = (value) => {
    const [year, month, day] = String(value || '').split('-').map(Number);
    return year && month && day ? new Date(year, month - 1, day) : null;
  };

  const iconMarkup = () => '<svg viewBox="0 0 24 24"><rect x="4" y="5.5" width="16" height="14" rx="2"/><path d="M8 3v5M16 3v5M4 10h16"/><path d="M8 14h3M13 14h3M8 17h3M13 17h3"/></svg>';

  const removeInsuranceOption = () => {
    const root = document.querySelector(SERVICE_SELECTOR);
    if (!root) return;

    root.querySelectorAll('.mw-apo-container .mw-option').forEach((option) => {
      const title = Array.from(option.querySelectorAll('.mw-option__title, .mw-option__label, .mw-text--style-strong'))
        .find((node) => !node.closest('.mw-option__value'))?.textContent || '';
      const values = Array.from(option.querySelectorAll('.mw-option__value-text, .mw-option__value-title'))
        .map((node) => node.textContent || '')
        .join(' ');
      if (!/versicherung/i.test(`${title} ${values}`)) return;

      option.dataset.bcuMovingInsuranceRemoved = 'true';
      option.hidden = true;
      option.setAttribute('aria-hidden', 'true');
      option.querySelectorAll('input, select, textarea').forEach((control) => {
        const wasSelected = control.matches('input[type="checkbox"], input[type="radio"]') && control.checked;
        if (wasSelected) control.checked = false;
        control.disabled = true;
        if (wasSelected) {
          control.dispatchEvent(new Event('input', { bubbles: true }));
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  };

  const enhanceDateStep = () => {
    const root = document.querySelector(SERVICE_SELECTOR);
    const step = root?.querySelector('[data-bcu-step="step-2"]');
    const container = step?.querySelector('[data-bcu-step-content]');
    const field = container?.querySelector('.bcu-service-local-field');
    const input = field?.querySelector('[data-bcu-local-field]');
    if (!container || !field || !input || input.dataset.bcuMovingDateEnhanced === 'true') return;

    container.querySelectorAll('.bcu-moving-date-status').forEach((element) => element.remove());

    input.dataset.bcuMovingDateEnhanced = 'true';
    input.name = 'properties[Gewünschtes Umzugsdatum]';

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const horizon = new Date(today);
    horizon.setMonth(horizon.getMonth() + Math.max(1, Number(config.horizonMonths || 3)));
    input.min = dateValue(today);
    input.max = dateValue(horizon);

    const existingLabel = field.querySelector(':scope > span');
    const icon = document.createElement('span');
    icon.className = 'bcu-moving-date-field__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = iconMarkup();

    const copy = document.createElement('span');
    copy.className = 'bcu-moving-date-field__copy';
    const heading = document.createElement('strong');
    heading.textContent = config.dateLabel || 'Gewünschtes Umzugsdatum';
    const instruction = document.createElement('small');
    instruction.textContent = config.dateInstruction || 'Gewünschtes Umzugsdatum im Kalender auswählen';
    copy.append(heading, instruction);

    existingLabel?.remove();
    field.classList.add('bcu-moving-date-field');
    field.prepend(icon, copy);

    const status = document.createElement('p');
    status.className = 'bcu-moving-date-status';
    status.id = `bcu-moving-date-status-${Math.random().toString(36).slice(2)}`;
    status.setAttribute('role', 'status');
    status.hidden = true;
    input.setAttribute('aria-describedby', status.id);

    container.append(status);

    const validate = () => {
      input.setCustomValidity('');
      status.hidden = true;
      status.classList.remove('is-error');
      if (!input.value) return;

      const selected = dateFromValue(input.value);
      let error = '';
      if (!selected) error = 'Bitte wählen Sie ein gültiges Umzugsdatum.';
      else if (selected.getDay() === 0) error = 'Sonntage sind nicht verfügbar. Bitte wählen Sie einen Termin von Montag bis Samstag.';
      else if (blockedDates.has(input.value)) error = 'Dieser Termin ist bereits belegt. Bitte wählen Sie ein anderes Datum.';

      if (error) {
        input.setCustomValidity(error);
        status.textContent = error;
        status.hidden = false;
        status.classList.add('is-error');
        return;
      }

      const formatted = new Intl.DateTimeFormat('de-CH', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      }).format(selected);
      const differenceDays = Math.round((selected - today) / 86400000);
      const threshold = Math.max(0, Number(config.shortNoticeDays || 0));
      status.textContent = threshold > 0 && differenceDays <= threshold
        ? `Gewünschtes Umzugsdatum: ${formatted} · Kurzfristige Anfrage`
        : `Gewünschtes Umzugsdatum: ${formatted}`;
      status.hidden = false;
    };

    input.addEventListener('input', validate);
    input.addEventListener('change', validate);
    validate();
  };

  const boot = () => {
    removeInsuranceOption();
    enhanceDateStep();
    const root = document.querySelector(SERVICE_SELECTOR);
    if (!root || root.dataset.bcuMovingOrganizationObserver === 'true') return;
    root.dataset.bcuMovingOrganizationObserver = 'true';
    const observer = new MutationObserver(() => {
      removeInsuranceOption();
      enhanceDateStep();
    });
    observer.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
